import type { EventDispatcher } from "@otto-ec/otto-components-utils/use";
import type { Events } from "../CinemaV1.types.js";
import type { CinemaItemState } from "./itemState.svelte.js";

export type ScrollSource = "arrows" | "pagination-dots" | "move-method" | "swipe";

export type ScrollDirection = "left" | "right";

export type VisibleItems = {
  /**
 *
 *
 *
 *
 *
 */
  elements: HTMLElement[];
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  indices: number[];
};

export interface ScrollEventDetail {
  visibleItems: VisibleItems;

  isScrolling: boolean;

  scrollDirection: ScrollDirection;

  source: ScrollSource;

  /*                         */
  scrollSource: ScrollSource;

  /*                              */
  stageIsScrolling: boolean;
}

export const getEventDetail = (
  items: HTMLElement[],
  visibleItems: HTMLElement[],
  currentItemIndex: number,
  prevCurrentItemIndex: number,
  stageScrolling: boolean,
  stageScrollSource: ScrollSource,
): ScrollEventDetail => {
  const detail: ScrollEventDetail = {
    visibleItems: {
      elements: visibleItems,
      indices: visibleItems.map((v) => items.indexOf(v)),
    },
    scrollDirection: currentItemIndex > prevCurrentItemIndex ? "right" : "left",
    isScrolling: stageScrolling,
    stageIsScrolling: stageScrolling,
    source: stageScrollSource,
    scrollSource: stageScrollSource,
  };
  return detail;
};

export const STAGE_SCROLL_EVENT = "oc-stage-scroll";
export const ITEM_VISIBILITY_CHANGED_EVENT = "oc-item-visibility-changed";
export const STAGE_SCROLL_COMPLETED_EVENT = "oc-stage-scroll-completed";

export const useScrollEvents = (
  itemState: CinemaItemState,
  dispatch: EventDispatcher<Events, false>,
  items: () => HTMLElement[],
  visibleItems: () => HTMLElement[],
  stageScrolling: () => boolean,
  stageScrollSource: () => ScrollSource,
): ((type: keyof Events, ...aliases: (keyof Events)[]) => void) => {
  return (type, ...aliases) => {
    /*                                                        */
    dispatch(
      type,
      getEventDetail(
        items(),
        visibleItems(),
        itemState.currentItemIndex,
        itemState.previosItemIndex,
        stageScrolling(),
        stageScrollSource(),
      ),
      { cancelable: false, alias: aliases },
    );
  };
};
